import { createSlice } from '@reduxjs/toolkit';
import { getMemberUserData } from './api-calls/members';

const INITIAL_STATE = {
  isFetchingUserData: false,
  isFetchingMemberData: false,
  //oidMemberData : {userOid : {userData: {}, memberData: {}}}
  oidMemberDataMap: {},
  failedUserDataFetch: {},
  failedMemberDataFetch: {},
};

export const membersSlice = createSlice({
  name: 'members',
  initialState: INITIAL_STATE,
  reducers: {
    setUserDataIdMap: (state, action) => {
      state.oidMemberDataMap = {
        ...state.oidMemberDataMap,
        [action.payload.email]: action.payload.data,
      };
    },
    deleteDataOfEmail: (state, action) => {
      const currentStateData = { ...state.oidMemberDataMap };
      console.log(currentStateData);
      delete currentStateData[action.payload.email];
      state.oidMemberDataMap = {
        ...currentStateData,
      };
    },
  },
  extraReducers: {
    [getMemberUserData.pending]: (state, action) => {
      state.isFetchingUserData = true;
    },
    [getMemberUserData.fulfilled]: (state, action) => {
      state.isFetchingUserData = false;
      console.log('new approach response success >>>>>', action);
      state.oidMemberDataMap[action.payload.email] = action.payload.data.data;
    },
    [getMemberUserData.rejected]: (state, action) => {
      state.isFetchingUserData = false;
      console.log('new approach response >>>', action);
    },
  },
});

export const { setUserDataIdMap, deleteDataOfEmail } = membersSlice.actions;

export default membersSlice.reducer;
